<template>
  <b-field label="Nom*" :message="error" :type="error !== null ? 'is-danger' : ''">
    <b-input :value="name" type="text" @input="input" />
  </b-field>
</template>

<script>
export default {
  name: 'NameField',

  props: {
    name: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      error: null,
    }
  },

  methods: {
    getError(name) {
      return name?.length < 1 ? `Le nom est requis` : null
    },

    input(name) {
      name = name.trim()

      this.error = this.getError(name)

      this.$emit('error', this.error !== null)

      if (this.error === null) {
        this.$emit('update:name', name)
      }
    },
  },
}
</script>
